import {getCookieVal} from "../utils/Cookie.js";
import {msg} from "@/i18n/Message.ts";

/* id of an element with value true/false */
export function setRefresh(mailIdent,idAccountElement)
{
    //console.log("setRefresh ah:"+idAccountElement);
	let rvCheckbox = $('#refreshVisibility');
	let accountHidden = $('#'+idAccountElement);
	let sharingTypeIsAuto = accountHidden.val() === 'true';

	rvCheckbox.prop('checked', sharingTypeIsAuto);
}

window.getMailParams = function(mailIdent,invert)
{
	if ($("#softCustomerPair") && $("#softCustomerPair").val()==="1") {
		return "customer=0";
	}
	else {
		return getOppParams(mailIdent)+",invert="+invert;
	}
};

window.getOppParams = function(mailIdent)
{
	let custPk = $('#customerFileAs_PK_').val();
	if(custPk && parseInt(custPk) > 0) return 'customer='+custPk;
	else return '';
};

window.getBusCaseParams = function(mailIdent)
{
	let oppPk = $('#opportunityName_PK_').val();
	let op = getOppParams(mailIdent);
	if(oppPk && parseInt(oppPk) > 0) {
		if (op.length>0) op = ','+op;
		return 'opportunity='+oppPk+op;
	} else return op;
};

window.applyTemplate = function(formId, templateListId, val = null)
{
	if (val == null) {
		// Get value from element
		let templateList = $('#'+templateListId);
		val = templateList.val();
	}

	if (val !== '0') {
		$('#useTemplate').prop("disabled", false);
		$('#'+formId).submit();
	}
	return false;
};


function endsWith(str, suffix)
{
	return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

window.getMailWindowHeight = function()
{
	let containerHeight = $(window).height(); //$('#container').height();
	let theHeader = $('#header').height();
	let theFooter = $('#footer').height();
	return containerHeight-theHeader-theFooter;
}

window.updateTitle = function(subj, defaultTitleKey)
{
	let newTitle = subj.value;
	if (newTitle === '') newTitle = msg(defaultTitleKey);
	document.title = newTitle;
};

/*function applyTemplate(formId, templateListId)
{
	let templateList = $('#'+templateListId);

	if (templateList.val() !== '0') {
		$('#useTemplate').prop("disabled", false);
		$('#'+formId).submit();
	}
	return false;
}*/

export function ckEditorResize(ck, mailIdent)
{
	let instance = ck.instances['mailForm('+mailIdent+').body'];
	instance.resize('100%',getMailWindowHeight()-41, true, true);
}

function getFileName(file)
{
	return file.name || file.fileName;
}

function styleTemplatePreview(subjectId,bodyId)
{
	let myHeight = parseInt(getCookieVal("crm_mailWindowHeight"),10)-250;
	if (!myHeight) myHeight = 400;
	let myWidth =  parseInt(getCookieVal("crm_mailWindowWidth"),10)-50;
	if (!myWidth) myWidth = 600;
	let myTop = parseInt(getCookieVal("crm_mailWindowTop"),10);
	if (!myTop) myTop = 50;
	else if (myTop>10) myTop=myTop-10;
	let myLeft = parseInt(getCookieVal("crm_mailWindowLeft"),10);
	if (!myLeft) myLeft = 50;
	else if (myLeft>10) myLeft=myLeft-10;

	let docHeight=$(document).height();
	//console.log(" MY H:"+myHeight);
	if(myHeight+myTop > docHeight)
	{
		myTop = 0;
		myHeight = 400;
	}

	let docWidth=$(document).width();
	//console.log(" MY W:"+myWidth);
	if(myLeft > docWidth)
	{
		myLeft = 50;
	}
	let params = "subject="+$("#"+subjectId).val()+"&body="+document.getElementById(bodyId).value+"&styleTemplate="+$("#styleTemplate").val();
	$.post("ajax/email_preview.jsp", params, function (data) {
		let rnd=Math.floor(Math.random()*1000);
		let win=window.open('about:blank','Email'+rnd,'width='+myWidth+',height='+myHeight+',left='+myLeft+',top='+myTop+',screenX=100,screenY=100,toolbar=0,location=0,directories=0,status=0,menubar=0,resizable=1,scrollbars=1');
		win.moveTo(myLeft, myTop);

		win.document.open();
		win.document.write(data);
		win.document.close();
	});
}
